import React from "react";

const InternshipTermsAndConditions = () => {
  return (
    <div className="content">
      <h3 className="mt-2 mb-1">Termos e Condições do Programa de Estágios</h3>
      {/* <p>
        O Agora Emprega prevê que cada vencedor/a conceda estágios profissionais
        e remunerados a pelo menos um estagiário e uma estagiária por um período
        de três (3) meses. Cada vencedor/a publica as oportunidades de estágio
        através da plataforma criada no âmbito do Agora Emprega, preenchendo
        todos os campos do formulário.
      </p>
      <p>
        Os jovens que procuram estágios podem candidatar-se para as vagas
        disponíveis nas suas áreas geográficas. A submissão de candidaturas é
        “online”, i.e., através da plataforma e requer o preenchimento dos
        campos padronizados do formulário de candidatura, dentro do prazo
        estipulado. O Candidato a estágio deve candidatar-se para as diversas
        vagas na sua cidade ou distrito. O Agora Emprega não irá cobrir custos
        de mudança do candidato de um distrito para outro.
      </p> */}
      <p>
        A plataforma regista as avaliações e permite extrair os melhores
        classificados para cada vaga em cada empresa. A equipa técnica do Agora
        Empresa extrai a lista e envia para a UGP e Banco Mundial para
        validação. Após a validação, são elaborados contratos de estágios
        simplificados entre o potencial estagiário, o recrutador e o INJ. A
        lista de estagiários apurados poderá ser publicada nas redes sociais da
        SEJE. Os estágios neste programa serão remunerados.
      </p>
      <p>
        É importante que este processo de criação de estágios profissionais
        observe o equilíbrio do género, ou seja, 50% das vagas criadas para
        estágio pelos vencedores sejam ocupadas por mulheres. Durante a
        realização dos estágios, nas empresas os/as estagiários/as deverão
        beneficiar de acompanhamento necessário para consolidar e desenvolver os
        conhecimentos e as habilidades adquiridas durante sua formação antes do
        estágio.
      </p>
      <p>
        No final do estágio será solicitado aos estagiários que avaliem até que
        ponto o estágio satisfez às suas expectativas e necessidades e, como
        poderiam ser supridas as insuficiências identificadas para responder
        melhor às expectativas.
      </p>
      <p>
        Os estagiários poderão durante o estágio recorrer ao Mecanismo de
        Reclamações e Resolução de Queixas para apresentar as suas preocupações
        em relação as questões do processo de estágio que não tiverem sido
        atendidas.
      </p>
    </div>
  );
};

export default InternshipTermsAndConditions;
